import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Box,
    Grid,
    Typography,
    Stack,
    Chip
} from '@mui/material';

import {
    blueGrey,
    lightBlue,
    teal,
    green
} from '@mui/material/colors';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const NEWS_ITEMS = [
    {
        size: { xs: 12, sm: 4, md: 4 },
        image: '/assets/images/news/exhibition_image.jpg',
        tag: '전시회',
        title: '2024 스마트 그린시티 박람회 참가',
        description: 'COEX · 2024. 05.',
        url: '/notices',
        tall: true,
    },
    {
        size: { xs: 12, sm: 8, md: 8 },
        image: '/assets/images/news/installation_image.jpg',
        tag: '적용 사례',
        title: '전국에 설치되어 있는 다끌레어를 찾아보세요',
        description: '2026년 2월 기준 전국 12곳 운영 중',
        url: '/company/locations',
        tall: false,
    },
    {
        size: { xs: 12, sm: 8, md: 8 },
        image: '/assets/images/news/VCM_image.jpg',
        tag: '비전',
        title: '탄소중립마켓(VCM) 오픈 준비 중',
        description: '자발적 탄소 시장에서 크레딧을 거래하고 ESG 목표를 달성하세요',
        url: '/services/vcm',
        tall: false,
    },
    {
        size: { xs: 12, sm: 4, md: 4 },
        image: '/assets/images/news/env_back3.jpg',
        tag: '고객 후기',
        title: 'SRT 도입 사례',
        description: 'SRT · 2024. 08.',
        url: '/notices',
        tall: true,
    },
];

function NewsCard({ item, navigate }) {
    const paddingBottom = item.tall ? '100%' : '50%';

    return (
        <Grid size={item.size}>
            <Box
                onClick={() => navigate(item.url)}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    width: '100%',
                    paddingBottom,
                    borderRadius: '16px',
                    cursor: 'pointer',
                    '&:hover .news-overlay': { opacity: 0.75 },
                    '&:hover .news-arrow': { transform: 'translateX(4px)' },
                    '&:hover .news-image': { transform: 'scale(1.05)' },
                }}
            >
                {/* 이미지 배경 */}
                <Box
                    className="news-image"
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: `url(${item.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transition: 'transform 0.5s ease',
                    }}
                />
                {/* 그라데이션 오버레이 */}
                <Box
                    className="news-overlay"
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.75) 100%)',
                        borderRadius: '16px',
                        opacity: 0.85,
                        transition: 'opacity 0.3s ease',
                    }}
                />
                {/* 태그 */}
                <Chip
                    label={item.tag}
                    size="small"
                    sx={{
                        position: 'absolute',
                        top: '20px',
                        left: '20px',
                        fontFamily: 'NotoSansKR',
                        fontWeight: 700,
                        fontSize: '11px',
                        backgroundColor: 'rgba(255,255,255,0.18)',
                        color: '#ffffff',
                        backdropFilter: 'blur(4px)',
                        border: '1px solid rgba(255,255,255,0.25)',
                    }}
                />
                {/* 텍스트 */}
                <Stack
                    direction="column"
                    spacing={0.5}
                    sx={{ alignItems:'flex-start', position: 'absolute', bottom: '24px', left: '24px', right: '24px' }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'NotoSansKR',
                            fontWeight: 900,
                            fontSize: item.tall ? '20px' : '22px',
                            color: '#ffffff',
                            lineHeight: 1.35,
                            textAligh:'left'
                        }}
                    >
                        {item.title}
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Typography
                            sx={{
                                fontFamily: 'NotoSansKR',
                                fontWeight: 400,
                                fontSize: '13px',
                                color: 'rgba(255,255,255,0.75)',
                                textAligh:'left'
                            }}
                        >
                            {item.description}
                        </Typography>
                        <ArrowForwardIcon
                            className="news-arrow"
                            sx={{
                                fontSize: '14px',
                                color: 'rgba(255,255,255,0.75)',
                                transition: 'transform 0.25s ease',
                            }}
                        />
                    </Stack>
                </Stack>
            </Box>
        </Grid>
    );
}

export default function NewsSection(props) {
    const navigate = useNavigate();

    return (
        <Box sx={{ my: 2, padding: '48px 0px 108px' }}>
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                sx={{ width: '100%' }}
                alignItems="stretch"
            >
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <Typography
                        sx={{
                            fontFamily: 'NotoSansKR',
                            fontWeight: 900,
                            textAlign: 'center',
                            fontSize: { xs: '26px', md: '42px' },
                            mb: '48px',
                            color: blueGrey[800],
                        }}
                    >
                        다끌레어는 이렇게 발전해갑니다
                    </Typography>
                </Grid>
                {NEWS_ITEMS.map((item) => (
                    <NewsCard key={item.title} item={item} navigate={navigate} />
                ))}
            </Grid>
        </Box>
    );
}
